<template>
	<dms-select-grid v-bind="{ span, labelKey: 'TYP_MASKA', disabled, validationOff, noLabelAlign }" @clear="clearClick">
		<dms-input :disabled="isDisabled" :value="value" label-key="TYP_MASKA" :span="8" :show-label="false" :wrapp="false" class="input-with-select"
			validation-off @update:value="$emit('update:value', $event)" />
		<dms-input :value="text" label-key="TEXT" :span="16" :show-label="false" :wrapp="false" class="input-with-select" validation-off disabled
			@update:value="$emit('update:text', $event)" />
		<template slot="buttons">
			<dms-button :disabled="isDisabled" :wrapp="false" text=".." type="primary" @click="openMKTridaSelect()" />
			<dms-button :disabled="isDisabled" :wrapp="false" text=".." type="primary" @click="openMKSkupinaSelect()" />
		</template>
	</dms-select-grid>
</template>

<script>
import { openSelectList } from '@/main/router/routerPath';
import { MASKA_MODELU } from '@/modules/ciselnik/dilenske/constants';

import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME as MK_TRIDA_NAME } from '../tabulkovaPozice/modelovyKlicTrida/constants';
import { NAME as MK_SKUPINA_NAME } from '../tabulkovaPozice/modelovyKlicSkupina/constants';

export default BaseSelect.extend({
	name: selectName(MASKA_MODELU),
	methods: {
		async openMKTridaSelect() {
			await openSelectList(
				MK_TRIDA_NAME,
				{
					afterRowSelection: this.selectedTrida,
					filter: this.filter,
				},
			);
			this.setPageManagerMapper();
		},
		async openMKSkupinaSelect() {
			await openSelectList(
				MK_SKUPINA_NAME,
				{
					afterRowSelection: this.selectedSkupina,
					filter: { ...this.filter, SkupinaMk: this.value },
				},
			);
			this.setPageManagerMapper();
		},
		selectedTrida({ row }) {
			const data = { value: row.TRIDA_MK, text: row[this.textFieldName] };
			if (this.mutationName) {
				this.$store.commit(this.mutationName, { data });
			} else {
				this.dataMapper({ data });
			}
		},
		selectedSkupina({ row }) {
			const data = { value: row.SKUPINA_MK, text: row[this.textFieldName] };
			if (this.mutationName) {
				this.$store.commit(this.mutationName, { data });
			} else {
				this.dataMapper({ data });
			}
		},
	},
});
</script>
